export const strings = {
  manufacturingInfo: 'コーヒー抽出設定',
  itemInfo: 'アイテム情報',
  save: '保存',
  notSet: '未設定',
}

export const itemInfoTableContent = {
  name: '名前',
  englishName: '名前 (英語)',
  price: '価格(税込)',
  priceExcludingTax: '価格(税抜)',
  disposalSeconds: 'ストック時間(秒)',
  category: 'カテゴリ',
  cupType: 'カップタイプ',
  description: 'ディスクリプション',
  descriptionEnglish: 'ディスクリプション (英)',
  story: 'コーヒーストーリー',
  storyEnglish: 'コーヒーストーリー (英)',
}

export const manufacturingInfoTableContent = {
  beanAmount: '豆投下量',
  beanTypeIndex: '豆レーン番号',
  machineButtonIndex: 'コーヒーマシンボタン番号',
}
